export const therapistToken: string = '__ttdata';
export const therapistRefreshToken: string = '__trdata';
export const therapistIdToken: string = '__trIdToken';

export const tokenType = 'Bearer'
